// Centralized color helpers for the Bulk Import feature.
//
// The accent is the APP THEME orange (`theme.app.secondary`, #E8650A) — use
// `props.theme.app.secondary` directly in styled-components for solid accent
// (background/border/accent-text). This module only holds the light accent
// surface/shadow the theme doesn't expose, the neutral greys (matching the
// shared `widgets/table` look), and the semantic status colors the theme
// doesn't expose as tokens. Goal: no scattered raw hex, colors aligned with
// the rest of the application.
//
// Near-duplicate greys previously scattered across the feature (#71717a,
// #525252, #57534e, #a1a1aa, #a3a3a3, #18181b on non-active text) are unified
// onto the canonical text tokens below.
export const bulkImportColors = {
    // ----- accent (orange) — solid accent = props.theme.app.secondary (#E8650A) -----
    // Light surface + shadow mirror the app's orange tab-active surface.
    accentSoft: '#fef2ed',
    accentShadow: 'rgba(232, 101, 10, 0.28)',

    // ----- neutral structure (matches shared widgets/table) -----
    surface: '#ffffff',
    border: '#e5e7eb',
    borderInput: '#d1d5db',
    rowDivider: '#f3f4f6',
    headerBg: '#f9fafb',
    rowHoverBg: '#fafafa',
    codeBg: '#f3f4f6',

    // ----- text -----
    textStrong: '#111827',
    textBody: '#1f2937',
    textHeading: '#374151',
    textSubtle: '#4b5563',
    textMuted: '#6b7280',
    textFaint: '#9ca3af',

    // ----- semantic: danger (until shared Badge/NotificationBanner replace these) -----
    danger: '#dc2626',
    dangerText: '#991b1b',
    dangerDeep: '#7f1d1d',
    dangerBorder: '#fecaca',
    dangerSurface: '#fef2f2',

    // ----- semantic: warning -----
    warning: '#f59e0b',
    warningText: '#92400e',
    warningSurface: '#fef3c7',
    warnBannerSurface: '#fefce8',
    warnBannerBorder: '#fde68a',

    // ----- semantic: success -----
    success: '#065f46',
    successText: '#166534',
    successSurface: '#d6f3e2',
    successSurfaceAlt: '#dcfce7',
    successSurfaceSoft: '#ecfdf5',
    successBorder: '#a7e3c0',

    // ----- semantic: info (blue) — neutral status accent the theme doesn't expose -----
    infoText: '#1e40af',
    infoSurface: '#eff6ff',
    infoBorder: '#bfdbfe',

    // ----- misc -----
    focusRing: '#3b82f6',
    mono: "'JetBrains Mono', 'Fira Code', monospace"
} as const;
